import { FC } from 'react';
import InfoBanner from './InfoBanner';
import Subtitle from 'components/Subtitle';
import { Badge } from '@mantine/core';
import { useSettings } from 'hooks/useSettings';
import { formatEventDateRange, formatDateWithFinnishWeekday } from 'utils/dateUtils';

const style = {
    infolabel: { marginBottom: 20 },
    label: { width: 100, marginRight: '10px'},
};

interface InfoLabelProps {
    label: string;
    message: string;
}

const InfoLabel: FC<InfoLabelProps> = ({ label, message }: InfoLabelProps) => {
    return (
        <>
            <div style={style.infolabel}>
                <Badge radius="sm" style={style.label} color="violet.4">
                    {label}
                </Badge>
                {message}
            </div>
        </>
    );
};

const BasicInfo: FC = () => {
    const { settings } = useSettings();

    const eventTime =
        settings?.startDate && settings?.endDate ? formatEventDateRange(settings.startDate, settings.endDate) : '';

    const startDateFormatted = settings?.startDate ? formatDateWithFinnishWeekday(settings.startDate) : '';

    const endDateFormatted = settings?.endDate ? formatDateWithFinnishWeekday(settings.endDate) : '';

    return (
        <>
            <InfoBanner />
            <Subtitle title="Perustietoa" />
            <InfoLabel label="Ajankohta" message={eventTime} />
            <InfoLabel 
                label="Osoite" 
                message={settings?.venueAddress || "Itsenäisyydenkatu 9, 28100 Pori"} 
            />
            {settings?.contacts && settings.contacts.length > 0 && (
                <InfoLabel 
                    label="Lisätietoja" 
                    message={(() => {
                        const coordinator = settings.contacts.find((c: { role: string; isPublic?: boolean }) => c.role === 'coordinator' && c.isPublic);
                        if (coordinator) {
                            const parts: string[] = [];
                            if (coordinator.phone) parts.push(coordinator.phone);
                            if (coordinator.email) parts.push(coordinator.email);
                            return parts.join(' / ') || coordinator.name;
                        }
                        return '';
                    })()} 
                />
            )}
            <InfoLabel 
                label="Järjestäjä" 
                message={settings?.organizerName || "Tammilanit-yhteisö"} 
            />

            <p>
                Tällä lomakkeella ilmoittaudut Tammilaneihin{settings?.eventName ? ` - ${settings.eventName}` : ''}!
                {startDateFormatted && endDateFormatted && (
                    <>
                        {' '}
                        Lanit alkavat {startDateFormatted} klo 18 ja päättyy {endDateFormatted} klo 10.
                    </>
                )}
            </p>
            <p>
                Järjestämme CS 2 sekä Tekken 3 -turnaukset. Ilmoita meille myös turnausilmoittautumisessa jos haluat
                järjestää oman turnauksen haluamassasi pelissä!
            </p>
            <p>Tapahtuma on päihteetön</p>
            <p>
                Pelipaikkana toimii {settings?.venueName ? settings.venueName : 'Porin Helluntaikirkon alasali'}. 
                Konepaikkoja on kahdenlaisia.
            </p>
            <ul>
                <li>
                    {settings?.pricingStandardSeatLabel || 'Peruspaikka'} {settings?.pricingStandardSeatDimensions || '100x75cm'} {settings?.pricingStandardSeatPrice ? `${settings.pricingStandardSeatPrice}€` : '20€'}.
                </li>
                <li>
                    {settings?.pricingPremiumSeatLabel || 'Siunattu paikka'} {settings?.pricingPremiumSeatDimensions || '120x80cm'} {settings?.pricingPremiumSeatPrice ? `${settings.pricingPremiumSeatPrice}€` : '30€'}.
                </li>
            </ul>

            <p>
                {settings?.paymentInstructions || 'Paikkamaksu maksetaan lani-infossa ilmoitetuun Grilliporon tilinumeroon/Mobilepayhin.'}
            </p>
            <p>Ilmoittautumisen jälkeen saat sähköpostiisi linkin josta voit varata konepaikan.</p>
        </>
    );
};

export default BasicInfo;
